import Papa from 'papaparse';

export type CsvRow = { [column: string]: string };

export function parseCsvFile(file: File) {
  return new Promise<CsvRow[]>((resolve, reject) => {
    Papa.parse<CsvRow>(file, {
      header: true,
      skipEmptyLines: true,
      complete: ({ data }) => resolve(data),
      error: reject,
    });
  });
}

export function csvFromRows(rows: CsvRow[]) {
  return Papa.unparse(rows, { delimiter: ';', newline: '\n' });
}

export function downloadCsv(csv: string, name: string) {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  const link = document.createElement('a');

  link.href = url;
  link.download = `${name}.csv`;
  link.click();

  URL.revokeObjectURL(url);

  return link;
}
